import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'src/utils/translate';
import SocialButton from 'src/components/buttons/socialButton';
import linkUtils from 'src/utils/linkUtils';
import { trackFootfallEvent } from 'src/utils/footfall';
import footfallEventTypes from 'src/constants/footfallEventTypes';
import Card from 'src/components/card';
import Link from 'next/link';
import ReactMarkdown from 'react-markdown';

const SOCIAL_BUTTONS = {
  facebook: {},
  twitter: { prefix: 'https://twitter.com/' },
  instagram: { prefix: 'https://instagram.com/' },
  youtube: {},
};

const CommunityHomeAboutUs = ({ widget, community }) => {
  const socialButtons = Object.keys(SOCIAL_BUTTONS)
    .filter(buttonType => !!widget[buttonType]);

  if (socialButtons.length === 0 && !widget.description && !widget.website && !widget.phone) {
    return null;
  }

  const description = widget.description && widget.description.length > 110
    ? widget.description.slice(0, 110) + '...'
    : widget.description;

  return (
    <Card
      title={i18n.t('About us')}
    >
      <div className="community__widget__about-line">
        <ReactMarkdown source={description}/>
        {'  '}
        <Link
          as={`/${community.slug}/about`}
          href={`/community/communityAbout?slug=${community.slug}`}
        >
          <a
            onClick={() => {
              trackFootfallEvent(footfallEventTypes.CLICKED, {
                clickType: 'community-read-more',
                clickMetadata: { section: 'community-side-bar' },
              });
            }}
          >
            {i18n.t('Read more about')}{' '}{community.name} <span className="icon icon-right-open" />
          </a>
        </Link>
      </div>
      {widget.website && (
        <div className="community__widget__about-line">
          <a
            href={linkUtils.prepLink(widget.website)}
            target="_blank"
            onClick={() => {
              trackFootfallEvent(
                footfallEventTypes.CLICKED,
                {
                  clickType: 'community-website',
                  clickMetadata: { section: 'community-side-bar' },
                },
              );
            }}
          >
            {widget.website}
          </a>
        </div>
      )}
      {widget.phone && <div className="community__widget__about-line">{widget.phone}</div>}
      {socialButtons.length > 0 && (
        <div className="community__widget__about-line">
          {socialButtons.map(buttonType => {
            const prefix = SOCIAL_BUTTONS[buttonType].prefix;
            const href = prefix
              ? prefix + widget[buttonType]
              : linkUtils.prepLink(widget[buttonType]);
            return (
              <a
                href={href}
                key={`social-btn-${buttonType}`}
                target="_blank"
                onClick={() => {
                  trackFootfallEvent(
                    footfallEventTypes.CLICKED,
                    {
                      clickType: 'community-social-icon',
                      clickMetadata: { section: 'community-side-bar', element: buttonType },
                    },
                  );
                }}
              >
                <SocialButton brand={buttonType} />
              </a>
            );
          })}
        </div>
      )}
    </Card>
  );
};

CommunityHomeAboutUs.propTypes = {
  community: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
};

export default CommunityHomeAboutUs;
